import { render, staticRenderFns } from "./DevicesDataTable.vue?vue&type=template&id=4bd6b0ec"
import script from "./DevicesDataTable.vue?vue&type=script&lang=ts"
export * from "./DevicesDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports